export default __webpack_public_path__ + "static/media/gallery-wip-crystal_00.7ce0dced.jpg";